module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-italic.22e7b04e.woff";